
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guru-ai-bot",
      function () {
        return require("private-next-pages/guru-ai-bot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guru-ai-bot"])
      });
    }
  